(function (Drupal, $) {
  Drupal.behaviors.select2Init = {
    attach: (context) => {
      once('select2Init', 'select', context).forEach((selectElement) => {
        const $select = $(selectElement);
        const selectId = $select.attr('id');
        const $label = $(`label[for="${selectId}"]`);

        // Check if a label exists
        if ($label.length) {
          // Generate a unique ID for the label if it doesn't already have one
          let labelId = $label.attr('id');
          if (!labelId) {
            labelId = `label-${selectId}`;
            $label.attr('id', labelId);
          }

          // Initialize Select2
          $select.select2({
            width: 'resolve',
            theme: 'default',
          });

          // Set aria-labelledby on the select2-selection element
          const select2Selection = $select.next('.select2-container').find('.select2-selection');
          select2Selection.attr('aria-labelledby', labelId);

          // Add custom class to the Select2 container
          $select.next('.select2-container').addClass('gpei-select');
        } else {
          // Fallback initialization if no label is found
          $select.select2({
            width: 'resolve',
            theme: 'default',
          }).next('.select2-container').addClass('gpei-select');
        }

        // Add custom class to the Select2 dropdown on open
        $select.on('select2:open', () => {
          $('.select2-container--open .select2-dropdown').addClass('gpei-select-dropdown');
        });
      });
    },
  };
}(Drupal, jQuery));
